import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined } from '@ant-design/icons';

import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  List,
  Spin
} from "antd";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from '../../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import CustomButton from '../../../../../../components/custom/CustomButton';
import dayjs from "dayjs";
import TextArea from 'antd/es/input/TextArea';

const { Text } = Typography

const WaiveInterest = (props) => {

  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [paymentTypeData, setPaymentTypeData] = useState([]);

  useEffect(() => {
    getTemplate();
  }, []);


  function getTemplate() {


    const params = {
      command: "waiveinterest"
    }
    const url = `${apiConfig.Loans}/${state.loanId}/transactions/template`

    let body = {
      session,
      params
    };

    BOM.FetchReqAction(body, url, (err, res) => {

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;

        useForm.setFieldsValue({
          transactionAmount: objList?.amount,
          transactionDate: dayjs(BOM.FormatArrayDateWithoutYear(objList?.date)),
        });
      }
    });
  }


  function onCancel() {
    navigate("/detail-child-glim", { state: state });
  }

  const onSubmit = (formValues) => {

    formValues.transactionDate = BOM.DateTime(formValues.transactionDate, "only-date")

    const params = {
      command: "waiveinterest"
    }
    const url = `${apiConfig.Loans}/${state.loanId}/transactions`

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      session,
      params
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.waiveInterestMsg);
        navigate("/detail-child-glim", { state: state });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };
  return (

    <MainLayout isEnableRightSidebar={true} >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.waiveInterest}
        pageItems={staticConfig.waiveInterestBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}

          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
          >

            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.intrstWaivedOn}
                  name="transactionDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.intrstWaivedOn
                      ),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.intrstWaivedOn}`,
                      "select"
                    )}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionAmount}
                  name="transactionAmount"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.transactionAmount
                      ),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.transactionAmount}`,
                      "select"
                    )}
                  />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0"></Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.note}
                  name={"note"}
                >
                  <TextArea style={{ width: "100%", height: "10vh" }} placeholder='Please enter a note' />

                </Form.Item>
              </Col>
            </Row>


            <Row>
              <Divider />
              {BOM.HasPermission("WAIVEINTERESTPORTION_LOAN") &&
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#15CCAE"
                  colorText="black"
                  hoverBackground="#4FECA0"
                />}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>

        </Card>
      </Spin>

    </MainLayout>
  )
}

export default WaiveInterest